import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import Counter, { CounterStyles } from "./Counter.jsx";
import Text, { TextStyles } from "./Text.jsx";

export function BlockNumbersStyles(params = {}) {
    const { MobileBreakpoint } = params;
    return {
        "& .block-numbers": {
            display: "grid",
            gridAutoFlow: "column",
            justifyContent: "center",
            padding: "0 80px",

            "& .number": {
                textAlign: "center",

                "& small": {
                    fontSize: "30px",
                },

                "& .text": {
                    fontSize: "24px",
                },
            },

            // One number
            "&.numbers-1": {
                "& .number": {
                    display: "grid",
                    gridGap: "52px",
                    alignItems: "center",
                    wordBreak: "break-word",
                    gridAutoFlow: "column",
                    gridTemplateColumns: "1fr 1fr",

                    [MobileBreakpoint]: {
                        gridAutoFlow: "row",
                        gridTemplateColumns: "none",
                        gridGap: "0",

                        "& .text-h1": {
                            textAlign: "center",
                        },
                    },
                },

                "& .text-h1": {
                    fontSize: "120px",
                    textAlign: "right",
                },

                "& .text": {
                    fontSize: "24px",
                    textAlign: "left",
                },
            },

            // Two numbers
            "&.numbers-2": {
                gridTemplateColumns: "1fr 1fr",

                "& .text-h1": {
                    fontSize: "80px",
                },
            },

            // Three numbers
            "&.numbers-3": {
                gridTemplateColumns: "1fr 1fr 1fr",

                "& .number": {
                    padding: "20px",
                },

                "& .text-h1": {
                    fontSize: "60px",
                },
            },

            // Many numbers
            "&.many-numbers": {
                gridAutoFlow: "row",
                gridTemplateColumns: "500px 500px",
                gridGap: "40px",

                "& .text-h1": {
                    fontSize: "60px",
                },
            },

            [MobileBreakpoint]: {
                gridAutoFlow: "row",
                gridTemplateColumns: "none !important",
                gridGap: "40px",

                "& .number": {
                    "& .text-h1": {
                        fontSize: "40px !important",

                        "& small": {
                            fontSize: "16px !important",
                        },
                    },
                    "& .text": {
                        fontSize: "20px !important",
                    },
                },
            },
        },

        ...CounterStyles(params),
        ...TextStyles(params),
    };
}

export default function BlockNumbers(props) {
    const { Numbers } = props.variables;
    const LI = useLoremIpsum();

    const _Numbers = Numbers || LI.Numbers;
    if (!Array.isArray(_Numbers)) {
        console.warn("Numbers is not array!");
        return null;
    }

    const CNNumbers = ["block-numbers"];

    Numbers
        ? Numbers.length <= 3
            ? CNNumbers.push(`numbers-${Numbers.length}`)
            : CNNumbers.push("many-numbers")
        : CNNumbers.push("numbers-1");

    const elProps = toElementProps(props, { className: CNNumbers });
    return (
        <div {...elProps}>
            {_Numbers?.map(({ number, unit, text }, index) => (
                <div key={index} className="number">
                    <Counter className={["text-h1"]} number={number} unit={unit} />
                    <Text text={text} />
                </div>
            ))}
        </div>
    );
}
